import { FaPrint } from "react-icons/fa";
import ThreeDots from "../../../../../assets/Images/threeDots.svg";
import { ThreeDotsActionProps } from "../interface";
import Image from "../../../../atoms/Image";
import { MdOutlineDownloadDone } from "react-icons/md";

const ThreeDotsAction = ({ item, handlePrintSharePdf, handleReadyOrder }: ThreeDotsActionProps) => {
    return (
        <div className="table-data-width">
            <button
                className="btn dropdown-dots shadow-none action-button"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <Image src={ThreeDots} />
            </button>
            <ul
                className="dropdown-menu dropdown-menu-end dropdown-style zindex-tooltip"
                aria-labelledby="dropdownMenuButton1"
                style={{ width: "210px" }}
            >

                {/* Print Option */}
                <li>
                    <button
                        className="dropdown-item dropdown-item-size"
                        onClick={() => handlePrintSharePdf(item?.id)}
                    >
                        <div className="d-flex align-items-center">
                            <FaPrint />
                            <span className="ms-2 mb-0">Order Form Pdf</span>
                        </div>
                    </button>
                </li>
                <hr className="my-1" />

                {/* transfer order Option */}
                <li>
                    <button className="dropdown-item dropdown-item-size"
                        onClick={() => handleReadyOrder(item?.id)}>
                        <div className='d-flex align-items-center'>
                            <MdOutlineDownloadDone size={'1.2em'} />
                            <span className='ms-2 mb-0'>To Order Ready</span>
                        </div>
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default ThreeDotsAction;
